import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class FilesService {
  private _baseUrl: string = `${environment.apiUrl}/projects`;

  constructor(private _http: HttpClient) {}

  getFiles(id: number): Observable<any> {
    return this._http.get(`${this._baseUrl}/projects/files/`, {
      params: { project: id },
    });
  }

  uploadFile(id: number, file: File, file_type: string = '0'): Observable<any> {
    const formData = new FormData();

    formData.append('file', file);
    formData.append('project', id.toString());
    formData.append('file_type', file_type);
    return this._http.post(`${this._baseUrl}/projects/files/`, formData);
  }

  deleteFile(id: number): Observable<any> {
    return this._http.delete(`${this._baseUrl}/project/files/${id}/`);
  }
}
